module.exports = __webpack_public_path__ + "static/media/img01.bc8b2d29.jpg";